<template>
  <div :class="$style.search">
    <Title
      bold
      strong
      style="padding: 0 0.5em;"
    >
      查詢捐款記錄
    </Title>
    <RouterView />
  </div>
</template>

<script>
import Title from '@/components/Title.vue';

export default {
  components: {
    Title,
  },
};
</script>

<style lang="scss" module>
@import '~@/styles/02-tools/tools.box';

.search {
  @include box;
}
</style>
